import React, { useContext,useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined"
import PublishOutlinedIcon from "@material-ui/icons/PublishOutlined"
import AlertMui from "../core/AlertMui"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import Loading from "../core/Loading";

import useMediaQuery from "../../hooks/useMediaQuery"

import AlertContext from "../../context/alert/alertContext"
import AuthContext from "../../context/authentication/authContext"
import TableContext from "../../context/table/tableContext"
import { Delete } from "@material-ui/icons"
import "./bills.css";

const useStyles = makeStyles((theme) => ({
  containerTabs: {
    margin: "auto",
    textAlign: "center",
  },
  tabs: {
    marginLeft: "30px",
    color: "#707070",
    "&:hover": {
      color: "#12b1ee !important",
      borderBottom: "solid 1px #12b1ee",
    },
  },
  title:{
    fontFamily:'Poppins',
    fontStyle:"normal",
    fontWeight:'400',
    fontSize:'32px',
    lineHeight:'20px',
    color:'#001070',
    marginBottom:'46px'
  },

  gridContainer: {
    width:"100%",

},

topButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "right",
  padding:"10px, 20px",
  gap: "10px",
  hover:"#001070",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
button:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
deleteButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#DA291D",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  marginRight:"14px",
  '&:hover': {
    backgroundColor: '#DA291D',
    transform: 'translateY(-1px) !important'}

},

  importButton:{

    fontFamily:'Inter',
    fontStyle: 'normal',
    fontWeight:'500',
    fontSize:'14px',
    lineHeight: '20px',
    color:"#ffffff",
    backgroundColor: "#001070",
    textTransform: 'capitalize',
    padding: "10px, 20px",

  },
  tableCell:{
    padding:'5px',
    textAlign:'center',
    color: '#949CA9',

  },
  tableCellTitle:{
    textAlign:'center',
    color: '#000',
    backgroundColor:'#d9d9d9',
    padding:'10px',
    boxShadow: '0px -1px 0px rgba(0, 0, 0, 0.25)',
    border: '1px solid rgba(255, 255, 255, 0.25)',
    borderRadius: '5px',

  },
  

        referenceSelection:{
            border:'1px rgba(232, 233, 234, 1) solid',
            width:'200px',
            height:'38px',
            borderRadius:'6px',
            padding:'10px',
            fontSize: '16px',
            lineHeight: '22px',
            color:' #949CA9',
        },
}))

const NewBillReferences = (props) => {
  const authContext = useContext(AuthContext)
  const {  authenticatedUser } = authContext //closeSession,
  const [referenceSelection,setReferenceSelection] = React.useState()
  const [ data, setData] =useState()
  const isProvider = props.type === 2
  const classes = useStyles()
  const columns = [
    
    { name: "N° DOCUMENTO" },
    { name: "TIPO" },
    { name: "FECHA" },
    { name: "MOTIVO" },
    { name: "GLOSA" },
  ]

  function setGlosa(event){
    props.setGlosa(event.currentTarget.value)
  }
  function setReason(event){
      props.setReason(event.currentTarget.value)
  }

 function selectReference(event){
     if(event.currentTarget.selectedIndex>0){
        const dt = event.currentTarget.options[event.currentTarget.selectedIndex].value
     //   //console.log('selectReference',dt )

    }
  }

  React.useEffect(()=>{
     const rf = sessionStorage.getItem('referenceData')
     if(rf){
        const referenceData = JSON.parse(rf)
       // //console.log('referenceData',referenceData)
        if(referenceData ){
            if(referenceData.typesToRefer===referenceData.documentType){
                return
            }
            const dt = {
                number: referenceData.documentUniqueNumber ,
                type:referenceData.documentType,
                date:referenceData.documentDate,
            }
            setData([dt])

            const nrs = []
            referenceData.availableDocumentsToReference.forEach( x=> {

            if(x.availableReasonToRefer !== null){
                if(x.typesToRefer===referenceData.typesToRefer){
                    x.availableReasonToRefer.forEach( r=>{
                    const newReason={}
                      newReason.value=r.key
                      newReason.text= r.label
                      nrs.push({...newReason})
                })}
            }

            })
            setReferenceSelection(nrs)
        }
     }
  },[])

  return (
  <Grid item xs={12}>
    <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (

                <TableCell
                  key={index}
                  align={column.name === "Monto" ? "right" : "center"}
                  className={classes.tableCellTitle}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            { data && data.map((n,k) => {
              return (
                <TableRow key={k}>
                  <TableCell className={classes.tableCell}><div className="referenceCell">{n.number}</div></TableCell>
                  <TableCell className={classes.tableCell}><div className="referenceCell">{n.type}</div></TableCell>
                  <TableCell className={classes.tableCell}><div className="referenceCell">{n.date}</div></TableCell>
                  <TableCell className={classes.tableCell}><div className="referenceCell">

                       { referenceSelection &&
                           <select onChange={setReason} id="selectableReference" className={classes.referenceSelection}>
                               <option value="-1">Seleccione una Razón</option>
                               {referenceSelection.map((n,k)=>{
                                 return ( <option value={n.value} key={k} >{n.text}</option>)
                               })}
                           </select>
                       }

                  </div></TableCell>
                  <TableCell className={classes.tableCell}>
                    <div className="referenceCell">
                        <input type="text"  onChange={setGlosa}></input>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
  </Grid>
  )
}

export default NewBillReferences
